/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Pro_6Inputs */

const en_signup_feature_pro_6 = /** @type {(inputs: Signup_Feature_Pro_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key Names and Phrases (KNP) Manager`)
};

const fr_signup_feature_pro_6 = /** @type {(inputs: Signup_Feature_Pro_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionnaire de noms et phrases clés (KNP)`)
};

const de_signup_feature_pro_6 = /** @type {(inputs: Signup_Feature_Pro_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüsselnamen und -phrasen (KNP) Manager`)
};

const it_signup_feature_pro_6 = /** @type {(inputs: Signup_Feature_Pro_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsabile dei nomi e delle frasi chiave (KNP)`)
};

const ru_signup_feature_pro_6 = /** @type {(inputs: Signup_Feature_Pro_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Менеджер по ключевым именам и фразам (KNP)`)
};

const es_signup_feature_pro_6 = /** @type {(inputs: Signup_Feature_Pro_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerente de Nombres y Frases Clave (KNP)`)
};

const zh_cn2_signup_feature_pro_6 = /** @type {(inputs: Signup_Feature_Pro_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关键名称和短语 (KNP) 管理器`)
};

const ja_signup_feature_pro_6 = /** @type {(inputs: Signup_Feature_Pro_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キー名とフレーズ（KNP）マネージャー`)
};

const hi_signup_feature_pro_6 = /** @type {(inputs: Signup_Feature_Pro_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रमुख नाम और वाक्यांश (केएनपी) प्रबंधक`)
};

const pt_pt2_signup_feature_pro_6 = /** @type {(inputs: Signup_Feature_Pro_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerente de Nomes e Frases-Chave (KNP)`)
};

/**
* | output |
* | --- |
* | "Key Names and Phrases (KNP) Manager" |
*
* @param {Signup_Feature_Pro_6Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_6 = /** @type {((inputs?: Signup_Feature_Pro_6Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_6Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_feature_pro_6(inputs)
	if (locale === "de") return de_signup_feature_pro_6(inputs)
	if (locale === "it") return it_signup_feature_pro_6(inputs)
	if (locale === "ru") return ru_signup_feature_pro_6(inputs)
	if (locale === "es") return es_signup_feature_pro_6(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_feature_pro_6(inputs)
	if (locale === "ja") return ja_signup_feature_pro_6(inputs)
	if (locale === "hi") return hi_signup_feature_pro_6(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_feature_pro_6(inputs)
	return en_signup_feature_pro_6(inputs)
});